<template>
  <el-dialog
    title="Сформировать отчет по СЗВМ"
    append-to-body
    :visible="visible"
    :width="isMobile ? '95%' : '550px'"
    :before-close="resetDates"
    @close="() => $emit('close')"
  >
    <div class="szvmDates">
      <div class="szvmDates__item">
        <div class="szvmDates__item-title">Начало периода:</div>

        <el-date-picker
          v-model="date_from"
          placeholder="Начало периода"
          format="dd.MM.yyyy"
          value-format="yyyy-MM-dd"
        />
      </div>

      <div class="szvmDates__item">
        <div class="szvmDates__item-title">Конец периода:</div>
        <el-date-picker
          v-model="date_to"
          type="date"
          placeholder="Окончание периода"
          format="dd.MM.yyyy"
          value-format="yyyy-MM-dd"
        />
      </div>
    </div>
    <div class="szvmButton">
      <el-button type="primary" :disabled="!canSendQuery" @click="submitForm()">
        Сформировать выгрузку
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { endOfCurrentMonth, startOfCurrentMonth } from '@/helpers/date'

export default {
  name: 'DialogReportSzvn',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      date_from: startOfCurrentMonth(),
      date_to: endOfCurrentMonth(),
    }
  },
  computed: {
    canSendQuery() {
      return this.date_from && this.date_to && this.date_from < this.date_to
    },
  },
  methods: {
    submitForm() {
      const baseURL =
        process.env.NODE_ENV === 'production'
          ? process.env.VUE_APP_API_URL_PROD
          : process.env.VUE_APP_API_URL
      const token = localStorage.getItem('auth-token')

      const link = document.createElement('a')

      link.href = `${baseURL}documents/szvm?token=${token}&date_from=${this.date_from}&date_to=${this.date_to}`
      document.body.appendChild(link)
      link.click()
      link.remove()
      setTimeout(() => {
        this.$message.success('Зпрос на формирование выгрузки отправлен')
        this.$emit('close')
        this.date_from = startOfCurrentMonth()
        this.date_to = endOfCurrentMonth()
      }, 1000)
    },
    resetDates(done) {
      this.date_from = startOfCurrentMonth()
      this.date_to = endOfCurrentMonth()
      done()
    },
  },
}
</script>

<style lang="sass" scoped>
.szvmDates
  display: flex
  gap: 20px
  margin-bottom: 40px
  font-family: "Rubik", sans-serif
  &__item-title
    margin: 0 0 8px 10px
.szvmButton
  display: flex
  justify-content: center
</style>
